import { ExpandableTable } from "../../../../components/UniversalTable";
import { documentTypeTableColumns } from "../../../../helpers";
import { BankStatementItem } from "../../../../types/verified/bank-statment";
import { useMemo } from "react";
import { ExpandedTableRow } from "./slices/ExpandedTableRow";
import { VerifyMethodType } from "shared/types";
import { VerificationSpecificAdditionaData } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { BankStatementTableRowData } from "./types";

export const BankStatementTable = ({
  incomeItems,
  additionalData
}: {
  incomeItems?: BankStatementItem[];
  additionalData?: VerificationSpecificAdditionaData[VerifyMethodType.BankStatement];
}) => {
  const bankStatements = useMemo(() => {
    const mappedBankStatements: BankStatementTableRowData[] = Array.from(
      new Set(incomeItems?.map((item) => item.income_source_id))
    ).map((incomeSourceId) => ({
      ...additionalData?.allBankStatements?.[incomeSourceId],
      usedItems: incomeItems?.filter(
        (item) => item.income_source_id === incomeSourceId
      ),
      verifyType: VerifyMethodType.BankStatement,
      companyName: additionalData?.companyName,
      incomeId: additionalData?.incomeId
    }));

    return mappedBankStatements.sort((a, b) => {
      const dateA =
        a.additional_data?.bank_statement_start_date ||
        a.additional_data?.earliest_transaction_date;
      const dateB =
        b.additional_data?.bank_statement_start_date ||
        b.additional_data?.earliest_transaction_date;

      if (!dateA) return 1;
      if (!dateB) return -1;

      return new Date(dateA).getTime() - new Date(dateB).getTime();
    });
  }, [incomeItems, additionalData]);

  return (
    <ExpandableTable
      cellClassName="p-4 pl-0 text-sm self-center"
      headerRowClassName="text-content-300"
      renderExpanded={(row) => {
        return (
          <div className="px-6 py-8 bg-background-900">
            <ExpandedTableRow rowData={row} />
          </div>
        );
      }}
      rows={bankStatements}
      columns={documentTypeTableColumns}
    />
  );
};
